import { ItemEsdevenimentProps, BotoEntradaProps } from './ItemEsdeveniment.types';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
const Boto: any = BotoComponent;
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Icona from 'components/corporatiu/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './itemEsdeveniment.module.scss';

const ItemEsdeveniment = (props: Readonly<ItemEsdevenimentProps>) => {
    const { titol, entradeta, avantitol, lloc, cos, imatges } = props;

    return (
        <div className={styles.itemEsdeveniment}>
            <div className={styles.capcalera}>
                <h1 className={styles.titol}>{titol}</h1>
                <p className={styles.entradeta}>{entradeta}</p>
                <div className={styles.info}>
                    <div>
                        <Icona
                            className={styles.icona}
                            icona='calendari'
                            alt='calendari'
                            isBlanc={true}
                            path='corporatiu'
                            mida='16'
                        />
                        <span>{avantitol}</span>
                    </div>
                    <div>
                        <Icona
                            className={styles.icona}
                            icona='ubicacio'
                            alt='marcador localització'
                            isBlanc={true}
                            path='corporatiu'
                            mida='16'
                        />
                        <span>{lloc}</span>
                    </div>
                </div>
            </div>
            <div className={styles.contentEsdeveniment}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        imatges={imatges}
                        tipus='web_destacat'
                        className={styles.imatge}
                        aria-hidden='true'
                        layout='fill'
                        mostrarRecurs={false}
                        priority={true}
                    />
                </div>
                <Text text={cos} className={styles.cos} />
            </div>
            <div className={styles.banner}>
                <div className={styles.bannerLogo}>
                    <Imatge
                        src='/_resources/imatges/corporatiu/enviu/logo-enviu.svg'
                        width={170}
                        height={120}
                        alt={titol}
                        priority={true}
                    />
                </div>
                <div className={styles.bannerText}>
                    Aquesta experiència forma part de 3Cat en Viu, un gran esdeveniment en què grans i petits podran gaudir en viu
                    dels continguts, programes, espectacles en directe, pòdcasts i activitats de l&apos;univers 3Cat
                </div>
                <div className={styles.bannerBoto}>
                    <Boto tag='a' className={styles.bannerBtn} link='/enviu/' estil='linedBlanc100' text="Informa-te'n" />
                </div>
            </div>
        </div>
    );
};

export default ItemEsdeveniment;
